export default __webpack_public_path__ + "static/media/mgm-logo.06dd844c.png";